import { render, staticRenderFns } from "./DriverAssignDialog.vue?vue&type=template&id=a00f8648&scoped=true"
import script from "./DriverAssignDialog.vue?vue&type=script&lang=js"
export * from "./DriverAssignDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverAssignDialog.vue?vue&type=style&index=0&id=a00f8648&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00f8648",
  null
  
)

export default component.exports